import asyncComponent from '../common/utils/async-component';

const CdnSettings = asyncComponent(() => import('./components/cdn-settings'));

export default {
  '/cdn': {
    components: { main: CdnSettings }
  }
};
